function dataFormatter(api, dataType, data) {
  const state = api.getState();
  const { formatter } = state.config;
  if (!formatter) {
    return data;
  }
  if (Array.isArray(data)) {
    return data.map((item) => formatter(dataType, item));
  }
  return formatter(dataType, data);
}
export {
  dataFormatter
};
